// statusUtils centralizes production-order status labels and badge colors for list/detail views.

export const PRODUCTION_ORDER_STATUS_OPTIONS = [
  { value: "", label: "Wszyscy" },
  { value: "draft", label: "Szkic" },
  { value: "active", label: "W realizacji" },
  { value: "closed", label: "Zamknięte" },
  { value: "cancelled", label: "Anulowane" },
] as const

const STATUS_LABEL_MAP: Record<string, string> = {
  draft: "Szkic",
  active: "W realizacji",
  closed: "Zamknięte",
  cancelled: "Anulowane",
}

const STATUS_COLOR_MAP: Record<string, string> = {
  draft: "gray",
  active: "blue",
  closed: "green",
  cancelled: "red",
}

// getProductionOrderStatusLabel converts backend status codes into Polish user-facing labels.
export function getProductionOrderStatusLabel(status?: string | null): string {
  if (!status) return "Nieznany"
  return STATUS_LABEL_MAP[status] ?? status
}

// getProductionOrderStatusColor returns the Chakra color scheme for a production-order status badge.
export function getProductionOrderStatusColor(status?: string | null): string {
  if (!status) return "gray"
  return STATUS_COLOR_MAP[status] ?? "gray"
}
